import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  dashboardUserRolesList: [],
  allFilterOptionsList: {},
  isValidUserRole: true,
};
export const GetAllFilterOptionsListThunk = createAsyncThunk(
  "dashboardUserRole/GetAllFilterOptionsListThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "Select filter_option_id,filter_option_name,display_name from  " +
            tablePrefix +
            "dashboard_filter_options order by display_name asc",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const ValidateUserRoleNameThunk = createAsyncThunk(
  "dashboardUserRole/ValidateUserRoleNameThunk",
  async (payload) => {
    let where = "";
    if (payload?.id != "") {
      where = " and user_role_id!='" + payload?.id + "'";
    }
    const queryBody = {
      queries: [
        {
          query:
            "select user_role_id from " +
            tablePrefix +
            "dashboard_user_roles where is_deleted!=1 and user_role_name='" +
            payload?.userRole +
            "' " +
            where,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllDashboardUserRolesListThunk = createAsyncThunk(
  "dashboardUserRole/GetAllDashboardUserRolesListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    const queryBody = {
      queries: [
        {
          query:
            "select user_role_id as id,user_role_name,profile from " +
            tablePrefix +
            "dashboard_user_roles where is_deleted!=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const CreateDashboardUserRoleThunk = createAsyncThunk(
  "dashboardUserRole/CreateDashboardUserRoleThunk",
  async (payload) => {
    let id = payload.id;

    let roleQry = "";
    let roleAssocQry = "";
    let queries = [];
    if (id === "" || id === null || id === undefined) {
      //Insert Case
      let newRoleId = uuid();
      let userRoleAssocId = uuid();

      roleQry =
        "Insert into " +
        tablePrefix +
        "dashboard_user_roles (user_role_id,user_role_name,profile) values('" +
        newRoleId +
        "','" +
        payload?.userRoleName +
        "','" +
        payload?.profile +
        "')";

      roleAssocQry =
        "Insert into " +
        tablePrefix +
        "dashboard_userrole_filteroptions_assoc (userrole_filteroption_assoc_id,user_role_id,avails_view,bids_view) values('" +
        userRoleAssocId +
        "','" +
        newRoleId +
        "','" +
        addslashes(payload.analyticDashboardTiles) +
        "','" +
        addslashes(payload.supplyDashboardTiles) +
        "')";

      queries = [
        {
          query: roleQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: roleAssocQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
    } else {
      //Update Case
      roleAssocQry =
        "Update " +
        tablePrefix +
        "dashboard_userrole_filteroptions_assoc set avails_view='" +
        addslashes(payload.analyticDashboardTiles) +
        "', bids_view='" +
        addslashes(payload.supplyDashboardTiles) +
        "' where user_role_id='" +
        id +
        "';";
      queries = [
        {
          query: roleAssocQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
    }

    const queryBody = {
      queries: queries,
    };

    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetDashboardUserRoleDetailsThunk = createAsyncThunk(
  "dashboardUserRole/GetDashboardUserRoleDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select ur.user_role_name,ur.user_role_id as role_id,ur.profile,ura.avails_view,ura.bids_view from " +
            tablePrefix +
            "dashboard_user_roles as ur left join " +
            tablePrefix +
            "dashboard_userrole_filteroptions_assoc as ura on ur.user_role_id=ura.user_role_id where ur.user_role_id='" +
            payload.id +
            "'  ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
const DashboardUserRole = createSlice({
  name: "dashboardUserRole",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(GetAllDashboardUserRolesListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDashboardUserRolesListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.dashboardUserRolesList = action.payload.data.results[0];
        }
        state.loading = false;
      })
      .addCase(GetAllDashboardUserRolesListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(GetAllFilterOptionsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllFilterOptionsListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          let dbFilterOptions = action.payload.data.results[0];
          let filterOptionsObj = {};
          dbFilterOptions.map((info) => {
            filterOptionsObj[info.filter_option_id] = {
              id: info.filter_option_id,
              name:
                info.display_name != "" &&
                info.display_name != null &&
                info.display_name != undefined
                  ? info.display_name
                  : info.filter_option_name,
              minMax: 0,
              isSelected: false,
            };
          });
          state.allFilterOptionsList = filterOptionsObj;
        }
        state.loading = false;
      })
      .addCase(GetAllFilterOptionsListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        //state.loading = false;
      })
      .addCase(CreateDashboardUserRoleThunk.pending, (state) => {
        //state.loading = true;
      })
      .addCase(CreateDashboardUserRoleThunk.fulfilled, (state, action) => {
        // if (!action.payload.data?.error) {
        //   let advertiserData = {
        //     name: action.meta.arg.name,
        //     account_id: action.meta.arg.account_id,
        //     email: action.meta.arg.email,
        //     margin: action.meta.arg.margin,
        //     revenue_share: action.meta.arg.rev_share,
        //     emailReports: action.meta.arg.email_report,
        //     emailReportType: action.meta.arg.email_report_type,
        //     emailReportTimezone: action.meta.arg.report_timezone_country,
        //     hasReportingPending: action.meta.arg.run_now,
        //   };
        //   state.advertiserDetails = advertiserData;
        // }
        //state.loading = false;
      })
      .addCase(CreateDashboardUserRoleThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        //state.loading = false;
      })
      .addCase(GetDashboardUserRoleDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDashboardUserRoleDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(GetDashboardUserRoleDetailsThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(ValidateUserRoleNameThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(ValidateUserRoleNameThunk.fulfilled, (state, action) => {
        if (!action.payload.data?.error) {
          console.log("Data:", action.payload.data);
        }
        state.loading = false;
      })
      .addCase(ValidateUserRoleNameThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
const { actions, reducer } = DashboardUserRole;
// Extract and export each action creator by name
export const {
  //resetRoleForm,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
